// extracted by css-extract-rspack-plugin
export default {"problemsWidget":"problemsWidget-BiZTbH"};